export default __webpack_public_path__ + "static/budny-6e12e056ca324e6dc69bd994e7658296.jpg";